import { useMutation } from '@tanstack/react-query';
import { markLessonFinish } from '../queries/lessons';

interface IBody {
  course: string;
  program: string;
}

export function useFinishLesson() {
  const { isSuccess, isPending, mutate } = useMutation({
    mutationKey: ['finish-lesson-from-card'],
    mutationFn: ({ slug, body }:{ slug: string, body: IBody | null }) => markLessonFinish(slug, body),
    retry: false
  });

  return {
    isLoading: isPending,
    mutate,
    isSuccess,
  };
}